import React from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useFormEnergyClass } from "./hooks/energy.hooks";
import { FormInput } from "common/components/form/hookForms/FormInput";
import { FormInputSuggestion } from "../../../components/form/FormInputSuggestion";

interface EnergyHeatingConsumptionFieldProps {
  consumptionLabel: string;
}

export const EnergyHeatingConsumptionField: React.FC<
  EnergyHeatingConsumptionFieldProps
> = ({ consumptionLabel }) => {
  const { t } = useTranslation();
  const { watch, setValue } = useFormContext();

  const { data } = useFormEnergyClass();
  const currentValue = watch("heatingConsumption");
  const address = watch("address");

  return (
    <>
      <FormInput
        units={t("property.units.heatingConsumption")}
        label={consumptionLabel}
        name="heatingConsumption"
        variant="decimal"
        maxWidth={500}
        showExternallyUpdatedDecimal
      />
      <FormInputSuggestion
        suggestionLabel={t("propertyForm.heatingConsumption.suggest", {
          consumption: data?.heating_consumption,
          units: t("property.units.heatingConsumption"),
        })}
        currentValue={currentValue}
        suggestedValue={data?.heating_consumption}
        onAgree={(value) => setValue("heatingConsumption", value)}
        source="Regia"
        address={address}
      />
    </>
  );
};
